<template>

  <div id="admin-members-list" class="admin-members wrap">
    <!-- / -->
    <h1 class="wp-heading-inline mb-3">会員リスト</h1>
    <!-- / -->
    <div class="d-none">
      <a href="/wp-admin/post-new.php?post_type=page" class="page-title-action">新規追加</a>
      <hr class="wp-header-end">
    </div>
    <!-- / -->
    <div id="memberListHead" class="mb-2 mb-md-3">
      <div class="d-flex flex-wrap mb-3">
        <!-- / -->
        <div class="d-flex align-items-center mb-2 mb-md-0">
          <label class="mr-2 mb-0">絞り込み：</label>
          <!-- / -->
          <b-form-select v-model="filter.approved"
                         v-bind:options="approved_filter_options"
                         size="sm"
                         id="filterByApproval"
                         class="selectApproval mr-2">
          </b-form-select>
          <!-- / -->
        </div>
        <!-- / -->
        <div class="searchInputBox d-flex align-items-center ml-md-auto">
            <b-form-input v-model.trim="filter.keyword"
                          v-on:keyup.enter="search_keyword"
                          type="text"
                          name="keyword"
                          class="searchInput mr-2"
                          placeholder="ID、名前、所属、メール">
            </b-form-input>
            <b-button v-on:click.prevent="search_keyword"
                      size="sm"
                      variant="outline-secondary"
                      class="btnFilter">
              会員を検索
            </b-button>
        </div>
      </div>
      <!-- Pagination -->
      <b-pagination v-model="pager.current_page"
                    v-bind:total-rows="total_members_num"
                    v-bind:per-page="pager.items_per_page"
                    align="right"
                    v-on:change="on_page_changed">
      </b-pagination>
      <!-- /Pagination -->
    </div>
    <!-- / -->
    <div id="memberListBody">
      <!-- / -->
      <table class="tblMemberList mb-2 mb-md-3">
        <!-- / -->
        <thead>
          <tr class="d-none d-xl-table-row">
            <th>会員ID</th>
            <th>名前</th>
            <th>変更</th>
            <th>所属機関及び役職</th>
            <th><span class="d-inline-block">メールアドレス</span><span class="d-inline-block">（ユーザーID）</span></th>
            <th>登録日時</th>
            <th>最終更新日時</th>
            <th>会員承認</th>
          </tr>
        </thead>
        <!-- / -->
        <tbody>
          <tr>
            <td v-if="loading.list" colspan="8" class="w-100 text-center py-4">
                <b-spinner label="Loading..."></b-spinner>
            </td>
          </tr>
        </tbody>
        <!-- / -->
        <tbody>
          <tr>
            <td v-if="!loading.list && members_in_this_page.length <= 0" colspan="8" class="text-center py-4">
                該当の会員は見つかりませんでした。条件を変更し、再度検索をお試しください。
            </td>
          </tr>
        </tbody>
        <!-- / -->
        <tbody v-if="!loading.list && members_in_this_page.length > 0">
          <!-- / -->
          <tr v-for="member in members_in_this_page">
            <th class="cellMemberId text-xl-center">{{member.id}}</th>
            <th class="cellMemberName">{{member.last_name +' '+ member.first_name}}</th>
            <td class="cellMemberEdit text-right">
              <a class="btn btn-sm btn-primary btnMemberEdit" v-bind:href="'./admin.php?page=members&id='+member.id">変更</a>
            </td>
            <td class="cellAffiliation">
              <div class="cellItemTtl">所　属</div>
              <div class="cellItemData">{{member.belonging}}</div>
            </td>
            <td class="cellMemberEmail">
              <div class="cellItemTtl">メールアドレス</div>
              <div class="cellItemData">{{member.email}}</div>
            </td>
            <td class="cellDate">
              <div class="cellItemTtl">登録日時</div>
              <div class="cellItemData">{{member.created_at}}</div>
            </td>
            <td class="cellDate">
              <div class="cellItemTtl">最終更新日時</div>
              <div class="cellItemData">{{member.updated_at}}</div>
            </td>
            <td class="cellApproval text-xl-center">
              <div class="cellItemTtl">会員承認</div>
              <div class="cellItemData">
                <!-- / -->
                <b-button v-if="!member.loading_approve && !member.approved_at"
                          v-b-modal.modal-approve
                          v-on:click.prevent="target_member(member.id)"
                          variant="primary"
                          size="sm"
                          class="btnApproval">
                  承認する
                </b-button>
                <!-- / -->
                <b-spinner small variant="info" v-else-if="member.loading_approve" label="Loading..."></b-spinner>
                <!-- / -->
                <span v-else-if="!member.loading_approve && member.approved_at" class="text-success font-weight-bold">承認済み</span>
                <!-- / -->
              </div>
            </td>
          </tr>
          <!-- / -->
        </tbody>
      </table>
    </div>
    <!-- / -->
    <div id="memberListFoot">
      <!-- Pagination -->
      <b-pagination v-model="pager.current_page"
                    v-bind:total-rows="total_members_num"
                    v-bind:per-page="pager.items_per_page"
                    align="right"
                    v-on:change="on_page_changed">
      </b-pagination>
      <!-- /Pagination -->
    </div>


    <!-- Modal Box -->
    <b-modal id="modal-approve"
             title="会員の承認"
             ok-title="承認する"
             ok-variant="primary"
             v-on:ok="approve_member(targeted_member.id)"
             cancel-title="キャンセル"
             cancel-variant="secondary"
             v-on:hidden="clear_targeted_member">
      <p class="my-2">
        <b-alert show variant="warning">
          会員ID：{{targeted_member.id}}<br>
          会員名：{{targeted_member.last_name +' '+targeted_member.first_name}}
        </b-alert>
        この会員を承認してよろしいですか？<br>
        承認することによって、会員はログインすることができるようになります。<br>
        （※承認の変更は後から変更することができます。）
      </p>
    </b-modal>
    <!-- /Modal Box -->
  </div>

</template>


<script>
    //import mixin
    import common from '../../../mixins/common';

    //vue
    export default {
        mixins: [common],
        data: function() {
          return {
            filter: {
              approved: null,
              keyword: ''
            },
            loading: {
              list: false
            },
            targeted_member: {
              id: null,
              first_name: null,
              last_name: null
            },
            members:{
              all: [],
              chunked: []
            },
            pager: {
              current_page: 1,
              items_per_page: 20
            },
            approved_filter_options: [
              {
                text:'すべて',
                value: null
              },
              {
                text:'会員未承認',
                value:'not_approved'
              },
              {
                text:'会員承認済み',
                value:'approved'
              }
            ],
            cookie: {
              approved: 'nakatani-db-admin-member-list-approved',
              keyword: 'nakatani-db-admin-member-list-keyword',
              pagenum: 'nakatani-db-admin-member-list-pagenum'
            },
            is_first_mounted: false
          }
        },
        computed: {
          members_in_this_page: function(){

            if(!this.members.all || this.members.all.length <= 0) {
              return [];
            }

            var chunked_index = this.pager.current_page-1;
            if(chunked_index < 0){
              chunked_index = 0;
            }
            return this.members.chunked[chunked_index];
          },
          total_members_num: function(){
            return this.members.all.length;
          },
          total_page_num: function(){
            return this.members.chunked.length;
          }
        },
        watch: {
          'filter.approved': function(new_val, old_val) {
            if(this.is_first_mounted) {
              //clear pagenum
              this.pager.current_page = 1;
              this.$cookies.set(this.cookie.pagenum,1,'/');
              //get member list
              this.get_members_list();
            }
          }
        },
        mounted() {
            console.log('MembersListComponent mounted.');

            //get cookie & set filter
            var cookie_approved = this.$cookies.get(this.cookie.approved);
            var cookie_keyword = this.$cookies.get(this.cookie.keyword);

            if(cookie_approved) {
              this.filter.approved = cookie_approved;
            }
            if(cookie_keyword) {
              this.filter.keyword = cookie_keyword;
            }

            //get members list
            this.get_members_list();
        },
        methods: {
          target_member: function(member_id) {
            this.targeted_member = _.find(this.members.all,{'id':member_id});
          },
          approve_member: function(member_id) {

            //this_member
            var this_member = _.find(this.members.all,{'id':member_id});

            //loading
            this_member.loading_approve = true;

            //api
            var _self = this;
            this.api().approve_member(member_id,function(api_response) {

              //result
              var result = api_response.data.result;
              if(result == 'SUCCESS') {
                _self.make_toast('会員を承認しました。','success');
                this_member.approved_at = moment().format('YYYY-MM-DD HH:mm:ss');

                //loading
                this_member.loading_approve = false;
              }
              else {
                _self.make_toast('会員の承認に失敗しました。','danger');

                //loading
                this_member.loading_approve = false;
              }
            });

          },
          clear_targeted_member: function() {
            this.targeted_member = {
              id: null,
              first_name: null,
              last_name: null
            };
          },
          on_page_changed: function(new_pagenum) {
            //set cookie
            this.$cookies.set(this.cookie.pagenum,new_pagenum,'/');
            //scroll
            this.scroll_to('#wpbody');
          },
          search_keyword: function() {
            //clear pagenum
            this.pager.current_page = 1;
            this.$cookies.set(this.cookie.pagenum,1,'/');
            //get member list
            this.get_members_list();
          },
          get_members_list: function() {

            //init
            this.loading.list = true;
            this.members.all = [];
            this.members.chunked = [];
            this.pager.current_page = 1;

            //set cookie
            this.$cookies.set(this.cookie.approved,this.filter.approved,'/');
            this.$cookies.set(this.cookie.keyword,this.filter.keyword,'/');

            //param
            var param = {
              approved: this.filter.approved,
              keyword: this.filter.keyword
            };

            //api
            var _self = this;
            this.api().get_members_list(param,function(api_response){

              //add param
              _.forEach(api_response.data,function(val,key){
                api_response.data[key]['loading_approve'] = false;
              });

              //all
              _self.members.all = api_response.data;

              //chunked
              _self.members.chunked = _.chunk(api_response.data,_self.pager.items_per_page);

              //cookie pagenum
              Vue.nextTick(function () {
                var cookie_pagenum = _self.$cookies.get(_self.cookie.pagenum);

                if(cookie_pagenum) {
                  if(cookie_pagenum >= _self.total_page_num || cookie_pagenum < 1) {
                    _self.pager.current_page = 1;
                    _self.$cookies.set(_self.cookie.pagenum,1,'/');
                  }
                  else {
                    _self.pager.current_page = Number(cookie_pagenum);
                  }
                }
                else {
                  _self.pager.current_page = 1;
                  _self.$cookies.set(_self.cookie.pagenum,1,'/');
                }

                //first mounted flag
                _self.is_first_mounted = true;

                //loading
                _self.loading.list = false;
              });

            });
          }
        }
    }
</script>
